var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ProgramOverviewCategory } from "core/codegen/types";
import { Dropdown } from "core/components/Dropdown";
import { ProgramOverviewCategoryLabels, } from "core/types";
import { Id } from "core/utils";
import React from "react";
import styled from "styled-components";
import { breakpoints, mq } from "core/styles/snippets";
export var CategoryField = function (_a) {
    var userInput = _a.userInput, setUserInput = _a.setUserInput, darkMode = _a.darkMode;
    var categoryOptions = __spreadArray([
        { value: "all", label: "Alle categorieën" }
    ], programOverviewCategoryKeys.map(function (item) { return ({
        value: ProgramOverviewCategory[item],
        label: ProgramOverviewCategoryLabels[item],
    }); }), true);
    return (React.createElement(Field, { options: categoryOptions, defaultValue: userInput.category, onChange: function (value) {
            setUserInput(__assign(__assign({}, userInput), { category: convertStringToCategory(value) }));
        }, componentId: Id.component.programsPage.search.category, identifier: "category-filter" }));
};
var convertStringToCategory = function (value) { return value; };
var programOverviewCategoryKeys = Object.keys(ProgramOverviewCategory);
var Field = styled(Dropdown)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  padding: 0;\n\n  ", " {\n    position: absolute;\n    right: 0.5rem;\n    top: 50%;\n    transform: translateY(-50%);\n    width: min-content;\n    height: 2.5rem;\n  }\n\n  ", " {\n    right: 1rem;\n  }\n"], ["\n  width: 100%;\n  padding: 0;\n\n  ", " {\n    position: absolute;\n    right: 0.5rem;\n    top: 50%;\n    transform: translateY(-50%);\n    width: min-content;\n    height: 2.5rem;\n  }\n\n  ", " {\n    right: 1rem;\n  }\n"])), mq.minWidth(breakpoints.medium), mq.minWidth(breakpoints.xlarge));
var templateObject_1;
